import React, { useRef } from 'react';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import CalculateIcon from '@mui/icons-material/Calculate';
import CachedIcon from '@mui/icons-material/Cached';

import {
  Popper,
  Fade,
  Paper,
  Box,
  Typography,
} from '@mui/material';
import useOnClickOutside from 'Shared/Hooks/useClickOutSide';
import { makeStyles } from '@mui/styles';
import { TYPES_ACHAT_CODE } from '../constants';

const useStylesActions = makeStyles(() => ({
  action: {
    display: 'flex', padding: '10px 15px', cursor: 'pointer', margin: '3px 0',
  },
  actionLabel: { marginLeft: 5, color: '#38485C', font: 'normal 600 16px Montserrat' },
}));
const ActionsDocuments = ({
  isOpen, onHandleDelete, onClose, anchorEl, onHandleCalculate, onHandleConvert, type,
}) => {
  const classes = useStylesActions();
  const refActions = useRef();
  useOnClickOutside(refActions, (e) => onClose({})(e));

  if (!isOpen) return null;
  const canConvert = [TYPES_ACHAT_CODE.BC, TYPES_ACHAT_CODE.PL, TYPES_ACHAT_CODE.BL].includes(type);
  return (
    <Popper
      sx={{ zIndex: 1200 }}
      open={isOpen}
      anchorEl={anchorEl}
      placement="bottom-end"
      transition
      ref={refActions}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Paper>
            <Box onClick={onHandleCalculate} className={classes.action}>
              <CalculateIcon />
              <Typography className={classes.actionLabel}>Calculer...</Typography>
            </Box>
            {canConvert && (
            <Box onClick={onHandleConvert} className={classes.action}>
              <CachedIcon />
              <Typography className={classes.actionLabel}>Converter...</Typography>
            </Box>
            )}
            <Box onClick={onClose} className={classes.action}>
              <EditOutlinedIcon />
              <Typography className={classes.actionLabel}>Modifier</Typography>
            </Box>
            <Box className={classes.action} sx={{ color: '#F86060' }} onClick={onHandleDelete}>
              <DeleteForeverOutlinedIcon />
              <Typography className={classes.actionLabel} style={{ color: '#F86060' }}>
                Supprimer
              </Typography>
            </Box>
          </Paper>
        </Fade>
      )}

    </Popper>
  );
};

export default ActionsDocuments;
